import Section from './Section/Section'

export default {
  Section
}
